/* eslint-disable no-param-reassign */
import type {} from '@redux-devtools/extension'; // required for devtools typing
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { type InjectedAccountWithMeta } from '@/shared/hooks/usePolkadot';

interface Store {
  polkadotAccount: InjectedAccountWithMeta | null;
}

interface Action {
  savePolkadotAccount: (account: InjectedAccountWithMeta | null) => void;
}

const useStore = create<Store & Action>()(
  devtools(
    persist(
      immer((set) => ({
        polkadotAccount: null,
        savePolkadotAccount: (account) =>
          set(
            (state) => {
              state.polkadotAccount = account;
            },
            false,
            'savePolkadotAccount',
          ),
      })),
      {
        name: 'cf.stake',
        version: 1,
        migrate: (persistedState, version) => {
          if (version === 0) {
            const state = persistedState as Store | null | undefined;
            if (state?.polkadotAccount) state.polkadotAccount.type = 'substrate';
          }

          return persistedState;
        },
      },
    ),
  ),
);

export default useStore;
